import React from 'react';
import { reactLocalStorage } from "reactjs-localstorage";

import Menu from '../components/menu/Menu';

import Const from '../util/Constants';
import Themes from '../util/Themes';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  
  static getDerivedStateFromError(_) {
    return { hasError: true };
  }
  
  componentDidCatch(_, errorInfo) {
    console.log(errorInfo.componentStack);
  }
  
  render() {
    if (this.state.hasError) {
      const user = reactLocalStorage.getObject(Const.LoggedInUser);
      let theme = user ? user.theme : undefined;
      theme = Themes.find((Theme) => Theme.value === theme);
      return(
        <div className={`header-bg-${theme ? theme.name : " "}`}>
          <Menu />
          <h1>Something went wrong. Please go to dashboard</h1>;
        </div>
      );
    }
    return this.props.children; 
  }
}
export default ErrorBoundary;